import { render, staticRenderFns } from "./Aroma.vue?vue&type=template&id=70c33685"
import script from "./Aroma.vue?vue&type=script&lang=js"
export * from "./Aroma.vue?vue&type=script&lang=js"
import style0 from "./Aroma.vue?vue&type=style&index=0&id=70c33685&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports